export class ParsedValue {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "format",
            "baseName": "format",
            "type": "string",
            "format": ""
        },
        {
            "name": "valueJson",
            "baseName": "valueJson",
            "type": "string",
            "format": ""
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ParsedValue.attributeTypeMap;
    }
    constructor() {
    }
}
